import React from 'react';
import Stack from "../ui/Stack";
import Icon from "../ui/Icon";
import {useDispatch} from "react-redux";
import {logout, setUserRole} from "../../store/auth-slice";
import {useNavigate} from "react-router-dom";
import Breadcrumb from "../Breadcrumb";
import RoleDropdown from "../dropdown/RoleDropdown";
import ProfileDropdown from "../dropdown/ProfileDropdown";
import Button from "../common/button/Button";
import {changeShowMenu} from "../../store/utility-slice";
// import OffCanvas from "../ui/OffCanvas";
import NotificationSidebar from "../notificationSidebar/NotificationSidebar";

const Header = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const logoutHandler = () => {
        dispatch(logout());
        navigate("/login");
    }

    const roleChangeHandler = (selectedRole) => {
        dispatch(setUserRole(selectedRole));
        navigate("/");
    }

    return (
        <>
            <header className="d-flex align-items-center justify-content-between py-4 px-5">
                <div className="me-auto d-flex align-items-center">
                    <Button className="d-block d-md-none me-2 bg-transparent"
                            onClick={() => dispatch(changeShowMenu())}>
                        <Icon name="menu" width="20px"/>
                    </Button>
                    <Breadcrumb className="mb-0"/>
                </div>
                <Stack className="column-gap-3 align-items-center">
                    <RoleDropdown onRoleChange={roleChangeHandler}/>
                    {/*<Theme />*/}
                    <button
                        className="btn btn-primary border-0 p-2 bg-primary bg-opacity-15 rounded-pill"
                        // data-bs-toggle="offcanvas"
                        // data-bs-target="#notificationOffcanvas"
                        // aria-controls="notificationOffcanvas"
                    >
                        <Icon name="notification" width="20px"/>
                    </button>
                    <ProfileDropdown onLogout={logoutHandler}/>
                </Stack>
            </header>
            <NotificationSidebar/>
        </>
    )
};

export default Header;
